export default __webpack_public_path__ + "static/media/om.df4d8bd4.svg";